import { Text, View } from "react-native";
import styles from "./EspaceValideur.styles";
import { ValideurDetailRowProps } from "./EspaceValideur.types";

export default function ValideurDetailRow({children, title, inline}: ValideurDetailRowProps){
    return (
        <View style={[styles.dialogCard, inline && styles.inline]}>
            {title && <Text style={[styles.sectionTitle]}>{title}</Text>}
            <Text style={[styles.subtitle]}>{children}</Text>
        </View>
    )
}
